import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { FlightCampaignsCard } from './FlightCampaignsCard'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'

const CardContainer = styled.div`
  min-width: ${rem(360)};
`

interface Props {
  campaigns: Array<App.FlightCampaign>
}

export function FlightCampaignsCarousel(props: Props) {
  const { campaigns } = props

  return (
    <FullWidthCarousel gap={24}>
      {campaigns.map(campaign => (
        <CardContainer key={campaign.id}>
          <FlightCampaignsCard
            title={campaign.title}
            endDate={campaign.end_date}
            subTitle={campaign.header}
            logoUrl={campaign.airline_logo}
            heroImageId={campaign.hero_image_public_id}
            id={campaign.id}
            hideTime={campaign.type === 'all'}
            price={campaign.price}
            fareClass={campaign.fare_class}
          />
        </CardContainer>
      ))}
    </FullWidthCarousel>
  )
}
